"use client";

import { useCookieConsent } from "./cookie-consent-provider";

export function CookieSettingsButton() {
  const { openPreferences } = useCookieConsent();

  return (
    <button
      type="button"
      onClick={openPreferences}
      className="font-mono text-sm text-muted-foreground transition-colors hover:text-primary"
    >
      Configuración de cookies
    </button>
  );
}
